import { Component } from '@angular/core';
import {TaggingLabelBuilderComponent} from "../../../shared/components/tag-canvas/tagging-label-builder.component";

@Component({
  selector: 'app-campaign-setup',
    imports: [
        TaggingLabelBuilderComponent
    ],
  templateUrl: './campaign-setup.component.html',
  styleUrl: './campaign-setup.component.scss',
})
export class CampaignSetupComponent {

}
